import { z } from "zod";
import { priceOptionsSchema } from "../schemas.js";

export default {
  params: z.object({
    name: z.string().trim().min(3),
    proAccountPriceOptions: priceOptionsSchema,
  }),
  response: z.object({
    supervisorOrgId: z.string(),
  }),
};
